import type { RouteObject } from 'react-router';
import { PageAgendas } from './PageAgendas';
import { PageRendezVous } from './PageRendezVous';

export const routesRendezVous: RouteObject[] = [
  { path: '/rendez-vous', element: <PageRendezVous vue="jour" /> },
  { path: '/rendez-vous/semaine', element: <PageRendezVous vue="semaine" /> },
  { path: '/rendez-vous/agendas', element: <PageAgendas /> },
];
